import classNames from 'classnames';
import { CSSProperties, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { PauseIcon, PlayIcon } from 'tdesign-icons-react';
import { Button, MessagePlugin } from 'tdesign-react';

import { stopPlayer } from '../utils/stopPlay';
import styles from './video-play.module.less';

export interface IPlayer {
  triggerPlay: () => void;
  pause: () => void;
  play: () => void;
  status: () => boolean;
}
/**
 * 视频播放器组件
 */
export const VideoPlayer = (props: {
  url: string;
  wrapWidth?: number;
  wrapHeight?: number;
  hiddenPlayBtn?: boolean;
  playRef?: React.ForwardedRef<IPlayer> | null;
  children?: React.ReactNode;
  controls?: boolean;
  controlsList?: string;
  wrapStyle?: CSSProperties;
  getStatus?: (status: boolean) => void;
}) => {
  const {
    url,
    wrapWidth,
    wrapHeight,
    playRef,
    hiddenPlayBtn = false,
    controls = false,
    controlsList,
    wrapStyle,
    getStatus,
  } = props;
  const videoRef = useRef<any>(null);

  useImperativeHandle(playRef, () => ({
    triggerPlay: () => handleTrigger(),
    pause: () => videoRef?.current?.pause?.(),
    play: () => videoRef?.current?.play?.(),
    status: () => isPlaying,
  }));

  const [isPlaying, setIsPlaying] = useState<any>(false);

  useEffect(
    () => () => {
      videoRef?.current?.pause();
    },
    [],
  );

  useEffect(() => {
    getStatus?.(isPlaying);
  }, [isPlaying]);

  const handleTrigger = async () => {
    try {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        await stopPlayer();
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    } catch (error) {
      MessagePlugin.error('该视频不支持预览');
    }
  };

  const stopPropagation = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
  };

  const pause = () => {
    setIsPlaying(false);
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener('pause', () => pause());
    }

    return () => {
      if (videoRef.current) {
        videoRef.current.removeEventListener('pause', () => pause());
      }
    };
  }, [isPlaying, pause]);

  return (
    <div
      onClick={stopPropagation}
      className={classNames(
        { [styles['preview-image']]: !hiddenPlayBtn },
        'nova-box-flex',
        { [styles['preview-image-hiddenPlayBtn']]: hiddenPlayBtn },
      )
      }
      style={{ width: wrapWidth, height: wrapHeight, ...wrapStyle }}
    >
      <div>
        <video
          preload="metadata"
          style={{ maxWidth: wrapWidth, maxHeight: wrapHeight }}
          ref={videoRef}
          src={url}
          controls={controls}
          controlsList={controlsList}
          onContextMenu={e => e.preventDefault()}
        />
      </div>
      <div className={classNames(styles['preview-image-op'], 'nova-box-flex')}>
        {props.children}
        {
          hiddenPlayBtn ? null
            : <Button
              shape="circle"
              icon={isPlaying ? <PauseIcon /> : <PlayIcon />}
              size="large"
              variant="text"
              onClick={handleTrigger}
            />
        }
      </div>
    </div>
  );
};
